(function ($, Drupal, drupalSettings, once) {

  'use strict';

  const container = document.querySelector('.js-footer-map');

  // Exit on pages where the container does not exist.
  if (!container) return;

  const button = container.querySelector('.js-footer-map-button');
  const buttonText = button.querySelector('span');
  const storeLocator = document.querySelector('.js-topnavstorelocator');
  const footer = container.closest('footer');

  const NOT_LOADED_YET = 'NOT_LOADED_YET';
  let requestedMutualId = NOT_LOADED_YET;
  let displayedMutualId = NOT_LOADED_YET;

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Globally accessible API
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Promutuel.footerMap = {
    personalizeUI(mutualId = Promutuel.mutuals?.getMyMutualId()) {
      // Exit if the map is not visible at all (e.g. on mobile devices).
      const rect = container.getBoundingClientRect();
      if (!rect.height || !rect.width) return;

      requestedMutualId = mutualId;

      if (Promutuel.windowing.isElementInViewport(footer)) {
        this.loadMap();
      }
    },

    async loadMap() {
      // Make sure we don't reload the same map over.
      if (requestedMutualId === displayedMutualId) return;
      displayedMutualId = requestedMutualId;

      // Save the button text so it can be safely changed later on.
      if (!buttonText.dataset.defaultText) buttonText.dataset.defaultText = buttonText.textContent;

      // Wait until the Google Maps API is available.
      await Promutuel.gmaps.initialize();

      const gmap = new google.maps.Map(
        container.querySelector('.js-footer-map-gmap'),
        {
          ...Promutuel.gmaps.getDefaultMapOptions(),
          zoomControl: false,
          fullscreenControl: false,
          gestureHandling: "none",
        }
      );
      // List of markers, to manage automatic center/zoom.
      const markers = [];

      // Reset the button's state.
      buttonText.textContent = buttonText.dataset.defaultText;
      button.removeEventListener('click', lookupClosebyMutual);

      // If a mutual is requested, display a few service outlets.
      if (displayedMutualId) {
        const detailedMutual = await Promutuel.mutuals.getMutualDetails(displayedMutualId);

        // If geolocation is enabled: display the 3 service outlets closest to the user.
        if (await Promutuel.geolocation.isGranted()) {
          const here = Promutuel.gmaps.toLatLng((await Promutuel.geolocation.getCurrentPosition()).coords);
          const distance = google.maps.geometry.spherical.computeDistanceBetween;

          // Get a clone of the outlets list.
          let outlets = [...detailedMutual.service_outlets];
          // Sort by distance to the user's location.
          outlets.sort((a, b) => {
            return distance(Promutuel.gmaps.toLatLng(a), here) - distance(Promutuel.gmaps.toLatLng(b), here)
          });

          // Only keep the 3 closest to the user.
          outlets.slice(0, 3).forEach(outlet => {
            markers.push(addMarker(
              Promutuel.gmaps.toLatLng(outlet),
              outlet.title,
              gmap,
            ));
          });
        }
        // If geolocation is disabled: display only the head office.
        else {
          const office = detailedMutual.head_office;
          markers.push(addMarker(
            Promutuel.gmaps.toLatLng(office),
            office.title,
            gmap,
          ));
        }

        // Customize the button.
        button.querySelector('span').textContent = detailedMutual.title;
        button.href = document.querySelector('.js-contact-us-menu')?.href || `${detailedMutual.url}#service-outlets`;
      }
      // No mutual currently selected: display the default, empty map.
      else {
        // If geolocation is enabled: center the map around the user.
        if (await Promutuel.geolocation.isGranted()) {
          const here = Promutuel.gmaps.toLatLng((await Promutuel.geolocation.getCurrentPosition()).coords);
          gmap.setCenter(here);
          gmap.setZoom(10);
        }

        // Customize the button.
        if (storeLocator) button.addEventListener('click', lookupClosebyMutual);
        else button.href = drupalSettings.path.contactUsUrl;
      }

      Promutuel.gmaps.fitMarkersIntoView(markers);
    },
  }

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Behaviors and event management
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Drupal.behaviors.promutuel_footerMap = {
    attach: function attach(context) {

      $(once('promutuelFooterMap', container, context)).each(async function() {
        footer.addEventListener('viewportenter', _ => {
          Promutuel.footerMap.loadMap();
        });
        Promutuel.windowing.enableViewportEvents(footer);
      });
    }
  };

  /*
    * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    * Utilities
    * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    */

  function addMarker(position, title, map) {
    return new google.maps.Marker({
      position,
      title,
      icon: {
        url: `${drupalSettings.path.baseUrl}${drupalSettings.path.themeUrl}/images/phylactere/${drupalSettings.path.currentLanguage}/phylactere.svg`,
        scaledSize: new google.maps.Size(48, 52),
        anchor: new google.maps.Point(0, 52),
      },
      map, // Attach the marker to the map immediately.
    });
  }

  // Event handler to trigger a geographic mutual search.
  async function lookupClosebyMutual(event) {
    event.preventDefault();

    Promutuel.header?.show();
    await Promutuel.topnavStoreLocator?.show();
    Promutuel.topnavStoreLocator?.panels.goTo(Promutuel.topnavStoreLocator.PANEL_FORM_POSTAL);
    storeLocator?.querySelector('.js-slocpc-geolocation').click();
  }

})(jQuery, Drupal, drupalSettings, once);
